/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import store from "./store/store"

Vue.use(Router);
const router = new Router({
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================

      path: "/dashboard",
      name: "dashboard",
      beforeEnter: gurdMyRoute,
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          name: "home",
          component: () => import("./views/Dashboard.vue")
        },
        {
          path: "/orders",
          name: "orders",
          component: () => import("./views/orders/Orders.vue"),
          beforeEnter: (to, from, next) => {
            if (store.getters.userRole.includes('Customer') || store.getters.userCustomer !== '') {
              next();
            } else {
              next({ name: 'dashboard' });
            }
          }
        },
        {
          path: "/add-order",
          name: "add-order",
          component: () => import("./views/orders/ECommerceCheckout.vue"),
          beforeEnter: (to, from, next) => {
            if (store.getters.userRole.includes('Customer') || store.getters.userCustomer !== '') {
              next();
            } else {
              next({ name: 'dashboard' });
            }
          }
        },
        {
          path: "/account-settings",
          name: "account-settings",
          component: () => import("./views/user-settings/UserSettings.vue"),
          beforeEnter: (to, from, next) => {
            if (store.getters.userRole.includes('Customer') || store.getters.userCustomer !== '') {
              next();
            } else {
              next(false);
            }
          }
        },
        {
          path: "/user-customers",
          name: "user-customers",
          component: () => import("./views/user/user-customers.vue"),
          beforeEnter: (to, from, next) => {
            if (!store.getters.userRole.includes('Customer')) {
              next();
            } else {
              next(false);
            }
          },
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      name: "login",
      component: () => import("@/views/pages/Login.vue"),
      beforeEnter: gurdMyRoute,
    },
    {
      path: "/register",
      component: () => import("@/views/pages/Register.vue")
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});
async function gurdMyRoute(to, from, next) {
  //check if the user is main user or customer
  let endPoint = 'Rest/mySettingsForm';

  const urlWithParams = new URL(
    `${process.env.VUE_APP_BASE_URL}${endPoint}`
  );

  urlWithParams.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);
  let permissionCheck = await fetch(urlWithParams.href, {
    method: "GET",
    mode: "cors",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  let userDetails = await permissionCheck.json();

  let settings = userDetails.settings;
  store.commit('UPDATE_USER_ROLE', settings.userRole);
  store.commit('UPDATE_USER_NAME_DOMAIN', settings.userName);

  const isLoggedIn = (settings.userName !== null && settings.userRole !== null);

  if (isLoggedIn) {
    // goto route if the route is not loggin and user is logged in
    if (to.name !== 'login') {
      next();
    } else if (to.name === 'login') { // goto home if route is login and user is logged in
      next({ name: 'home' });
    }
  } else if (!isLoggedIn) {
    if (to.name === 'login') { 
      next();
    }
    else if (to.name !== 'login') {//for all routes goto login if user is not logged in
      next({ name: 'login' });
    }
  }
}
export default router;
